// import * as types from '../store/mutation-types'
import { store, service } from '../main.js'
// import config from '../config'

export default {
  async GetWallet() {
    const response = await service.get('/wallet/user/' + store.getters['user/info'].ID, 'userwallet')
    if (response.data) {
      // call the action to commit here
      store.dispatch('user/setWallet', response.data)
    }
    return response.data
  },
  async GetPSPBlockedCountries() {
    return await service.get('/finance/psp-blocked-countries', null, 'pspblockedcountries').then(response => {
      if (response.data.PSPs) {
        // call the action to commit here
        store.dispatch('finance/setPSPBlockedCountries', response.data.PSPs)
      }
      return response.data.PSPs;

    })
  },
  async GetAllowedWithdrawProviders() {
    return await service.get(`/finance/allowed-withdraw-providers/${store.getters['user/info'].ID}`).then(response => {
      if (response.data && response.data.providers) {
        // Dispatch action to commit allowed providers
        store.dispatch('finance/setAllowedWithdrawProviders', response.data.providers);
      }
      return response.data.providers

    })

  },

  async GetAllowedDepositProviders() {
    return await service.get(`/finance/allowed-deposit-providers/${store.getters['user/info'].ID}`).then(response => {
      if (response.data && response.data.providers) {
        // Dispatch action to commit allowed providers
        store.dispatch('finance/setAllowedDepositProviders', response.data.providers);
      }
      return response.data.providers

    })

  },

  async GetUserAccountTypes() {
    return await service.get('/users/account-types/' + store.getters['user/info'].ID, 'useraccounttypes').then(response => {
      if (response.data.accountTypes) {
        // call the action to commit here
        store.dispatch('user/setAccountTypes', response.data.accountTypes)
      }
      // Return the response to use it later
      return response.data.accountTypes;
    })
  },
  GetTradingAccounts() {
    return new Promise((resolve, reject) => {
      return service
        .post('/ta/user', {
          userID: store.getters['user/info'].ID,
          includeDeleted: true
        })
        .then(response => {

          let TA = response?.data?.TAs || [];
          // remove if PAMM account become available
          // TA = TA.filter((t) => t.platform !== 'pamm')
          // TA = TA.map(ta => {
          //   const b = parseFloat(ta.balance).toFixed(2);
          //   const e = parseFloat(ta.equity).toFixed(2);
          //   const cs = config.currencies[ta.currency];
          //   ta.balance = isNaN(b) ? '' : b
          //   ta.balance_format = isNaN(b) ? '' : `${cs} ${b}`
          //   ta.equity = isNaN(e) ? '' : e
          //   ta.equity_format = isNaN(e) ? '' : `${cs} ${e}`
          //   return ta
          // })
          // call the action to commit here
          store.dispatch('user/setTA', TA)
          resolve(response)
          return TA
        })
        .catch(reject)
    })
  },
  async GetDocumentCount() {
    return await service.get('/documents/user/' + store.getters['user/info'].ID)
      .then(response => {
        let count = 0;

        if (response.data && response.data.Documents) {
          const docs = response.data.Documents;
          for (let doc of docs) {
            if (doc.document_status !== 'rejected') {
              count++;
            }
          }
        }

        // Store the count in Vuex
        store.dispatch('user/setDocCount', count);

        // Return the count for later use
        return count;
      })
  },

  async GetBonusData() {
    if (store.getters['user/info'] && store.getters['user/info'].ID > 0) {
      try {
        const response = await service.post('/bonus/' + store.getters['user/info'].ID ,{});

        // Check if response.data exists and has Bonuses, else fallback to an empty array
        const bonuses = response.data?.Bonuses || [];

        // Dispatch to store if bonuses exist
        if (bonuses.length > 0) {
          store.dispatch('bonusconfig/setBonusData', bonuses);
        }

        // Return the normalized bonuses
        return bonuses;
      } catch (error) {
        return []; // Return an empty array on error
      }
    }
    return [];
  },
  async GetCurrentCompetition() {
    const res = await service.get(`/trading-competition/${store.getters['user/info'].ID}`)
    if(res.data) {
      store.dispatch('competition/setCurrentCompetition', res.data.current_competition)
      store.dispatch('competition/setHasEnteredCompetition', res.data.user_join)
    }
  },

  async GetUserIB() {
    return await service.get(`/ib/${store.getters['user/info'].ID}`).then(response => {
      if (response.data) {
        store.dispatch('user/setIB', response.data);
      }
      return response.data

    })
  }
}
